import type { RouteRecordRaw } from 'vue-router'
import { ScheduledRoutes } from '@/routes/user/scheduled/types'
import { AppModule } from '@/config/types'

export const scheduledCalenderRoutes: RouteRecordRaw = {
  name: ScheduledRoutes.calendar,
  path: 'calendar/:viewType?/:date?',
  meta: {
    tags: ['SCHEDULED_BAR_LIST'],
    tabTitle: 'pageTabTitle.user.scheduled.calendar',
    modules: [AppModule.ScheduledCalendar, AppModule.Recipient, AppModule.ScheduledEmail],
  },
  component: () => import('@/components/views/scheduled/ScheduledCalendarWrapper.vue'),
}
